/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn24_visa': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 1.25A5.75 5.75 0 001.25 7v10A5.75 5.75 0 007 22.75h10A5.75 5.75 0 0022.75 17V7A5.75 5.75 0 0017 1.25H7zM2.75 7A4.25 4.25 0 017 2.75h10A4.25 4.25 0 0121.25 7v10A4.25 4.25 0 0117 21.25H7A4.25 4.25 0 012.75 17V7zm13.413 1.462a.75.75 0 00-1.39-.563l-2.734 6.748-2.074-6.689a.75.75 0 00-.716-.528h-.79a.75.75 0 100 1.5h.237L11.23 17.1a.75.75 0 001.412.06l3.522-8.697z" _fill="#000"/>'
  }
})
